import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { WorkOrder, WorkOrderEstmatedDate, WorkOrderSearchCommand } from '../../models/order/work-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private _baseUrl = `${environment.proxyUrls.orderApi}/api/v1/work-order`;

  getById(id: string, materialize = false): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.get<ApiResponse<WorkOrder>>(`${this._baseUrl}/${id}?materialize=${materialize}`);
  }
  public search(
    command: WorkOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<WorkOrder>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) {
      params = params.set('sortField', sortField).set('sortOrder', sortOrder.toString());
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<WorkOrder>>>(`${this._baseUrl}/search`, command, { params });
  }

  public patchWorkOrdeEstimatedDate(
    id: string,
    workOrderEstmatedDate: WorkOrderEstmatedDate,
  ): Observable<ApiResponse<WorkOrderEstmatedDate[]>> {
    return this.httpClient.patch<ApiResponse<WorkOrderEstmatedDate[]>>(
      `${this._baseUrl}/${id}` + '/estimated-dates',
      workOrderEstmatedDate,
    );
  }

  public getWorkOrders(): Observable<ApiResponse<WorkOrder[]>> {
    return this.httpClient.get<ApiResponse<WorkOrder[]>>(`${this._baseUrl}/all`);
  }
}
